import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ProcessoStatusService } from '../services/processo-status.service';

@Injectable({
  providedIn: 'root',
})
export class ProcessoStatusResolver implements Resolve<boolean> {
  constructor(private service: ProcessoStatusService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}
